// extracted by mini-css-extract-plugin
export default {"l_AlertIcon_main":"AlertIcon_l_AlertIcon_main__GHrEJ","l_AlertIcon_img":"AlertIcon_l_AlertIcon_img__3J7q7"};